//TODO: Este documento se crea para las apis que se ocuapn de paquetes V2 del mayorista

import axios from "axios"
import { APIURL } from "./../Constantes"
import { getCabecera } from "../utils/getCabecera"
import { getError } from "../utils/errors"
const urlSupplier = "Supplier"

//* Metodo para obtener los preoveedores terrestres catalog de proevedores
//* GET api/Supplier/Ground
export const getProveedoresTerrestresCatalogo = async () => {
    return await axios.get(`${APIURL}/${urlSupplier}/Ground`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return []
        // return getError(Error);
    })
}

//* Metodo para obtener los preoveedores terrestres catalog de proevedores
//* GET api/Supplier/Air
export const getProveedoresAereosCatalogo = async () => {
    return await axios.get(`${APIURL}/${urlSupplier}/Air`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return []
        // return getError(Error);
    })
}